import { IconName } from '@usealloy/component-library';
import styled, { css } from 'styled-components';

import { Sidebar } from '../component/Sidebar';

const FLYOUT_CARET_SELECTOR = `
  [data-icon-name="${IconName.CaretRight}"],
  [data-icon-name="${IconName.CaretDown}"]
`;

/**
 * Shared hover/focus-reveal styles for trailing caret icons on flyout triggers.
 * Use on non-MenuButton bases (e.g. customer switcher SidebarMenuItem).
 */
export const hoverRevealCaretStyles = css`
  ${FLYOUT_CARET_SELECTOR} {
    opacity: 0;
    transition-property: opacity;
    transition-duration: var(--cl-duration-300);
    transition-timing-function: var(--cl-motion-ease-in-out);
  }

  &:hover ${FLYOUT_CARET_SELECTOR}, &:focus-visible ${FLYOUT_CARET_SELECTOR} {
    opacity: 1;
  }
`;

/**
 * Shared Sidebar.MenuButton with hover/focus caret reveal.
 * Used by profile + Resources flyout triggers (parity with frontend-dashboard).
 */
export const StyledFlyoutTriggerButton = styled(Sidebar.MenuButton)`
  ${hoverRevealCaretStyles}
`;
